module.exports = __webpack_public_path__ + "static/media/ding.cd64fe4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/pages/suspect/ding.mp3
// module id = vBrz
// module chunks = 1